/* eslint-disable no-nested-ternary */
import React, { useEffect, Fragment, useContext } from 'react';
import { formatPostDate } from '@mummssoftware/utils/formatters';
import { OrdersGlobalContext } from '@mummssoftware/global-context/OrdersGlobalContext';
import { Context } from '../../context';
import { ProgressNotesContext } from '../Context/ProgressNotesContext';
import {
  StyledMenuSpan,
  MenuDiv,
  MenuContentDiv,
} from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';
import { IDG } from '../Context/constants';

type IDGMenuProps = {
  note: mumms.progressNotebyEntity | mumms.progressNote | null;
};

const IDGMenu = ({ note }: IDGMenuProps) => {
  const {
    updateProgressNoteEntity,
    updateProgressNotes,
    agency,
    patient,
    currentUser,
  } = useContext(Context);
  const { savedNote } = useContext(OrdersGlobalContext);

  const { idgMeeting, closeTagMenu } = useContext(ProgressNotesContext);

  const hasIDGmeeting = !!(idgMeeting && idgMeeting.length);

  const updatePNoteEntity = async (progressNoteEntityData: any) => {
    const method = 'POST';
    await updateProgressNoteEntity(agency, progressNoteEntityData, method);
    closeTagMenu();
  };

  const updatePNotes = async () => {
    await updateProgressNotes(patient.patientNumber, agency);
  };

  // on Mount if hasIDGmeeting API call
  useEffect(() => {
    if (hasIDGmeeting && note) {
      const meeting = idgMeeting[0];
      const progressNoteEntityData = meeting && {
        entitykey: '-1',
        entitytypeshortname: IDG,
        patientprogressnoteid: note?.id,
        createdatetime: formatPostDate(new Date()),
        createpersonid: currentUser?.userId,
        createpersonnumber: currentUser?.personNumber,
      };
      updatePNoteEntity(progressNoteEntityData);
    }
    return () => {
      // @note no savedNote means we are NOT adding a note from the bottom
      // @note updatedNote is not reflected here as this is ON MOUNT
      // @note useEffect on updatedNote would not work as UNMOUNT first

      if (!savedNote && hasIDGmeeting) {
        updatePNotes();
      }
    };
  }, []);

  const getIDGMenu = () =>
    hasIDGmeeting ? (
      <>
        <MenuContentDiv>{defaults.tagIDG}</MenuContentDiv>
      </>
    ) : !idgMeeting ? (
      <StyledMenuSpan>{defaults.loadingIDG}</StyledMenuSpan>
    ) : (
      <StyledMenuSpan>{defaults.noIDG}</StyledMenuSpan>
    );
  const getMenuContent = () =>
    note ? <MenuDiv>{getIDGMenu()}</MenuDiv> : <div>{defaults.noNote}</div>;

  return <Fragment>{getMenuContent()}</Fragment>;
};

export default IDGMenu;
